/**
 * Copyright (c) 2026 ForgeRock. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

export const DEPLOYMENT_TYPES = {
  PLATFORM: 'PLATFORM',
  IDM: 'IDM',
};
